import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './style.scss';


const BookRating = ({ value, isTiny, showNumericValue }) => {
  const sizeWidth = isTiny ? value * 16 : value * 20;
  const filledWidth = Math.round(sizeWidth * 10) / 10;
  const ratingStyle = {
    width: `${filledWidth}px`,
  };

  return (
    <div className={styles.bookRating}>
      <div className={classNames(styles.rating, isTiny ? styles.tiny : '')}>
        <div className={classNames(styles.ratingInner, { isTiny })} style={ratingStyle} />
      </div>
      {showNumericValue && (
        <div className={classNames(styles.ratingValue, { isTiny })}>
          {value.toPrecision(2).replace('.', ',')}
        </div>
      )}
    </div>
  );
};

BookRating.propTypes = {
  value: PropTypes.number,
  isTiny: PropTypes.bool,
  showNumericValue: PropTypes.bool,
};

BookRating.DefaultProps = {
  value: 100,
  isTiny: false,
  showNumericValue: false,
};

export default BookRating;
